"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinancialServicesOverview() {
  return <section data-section-id="258377" id="healing-modalities" className="text-foreground py-[60px] px-6 md:px-10 light bg-muted">
      <div className="max-w-7xl mx-auto">
        <div className="hidden md:grid md:grid-cols-2 md:gap-12 md:items-center">
          <div className="relative flex justify-center">
            <div className="absolute w-80 h-80 rounded-lg" style={{
            backgroundColor: "hsl(145, 15%, 85%)",
            top: "20px",
            right: "-20px",
            zIndex: 0
          }} />
            <div className="relative z-10 w-72 h-64 rounded-lg overflow-hidden shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/serene_spa_treatment.png" alt="Holistic Body Therapy" className="h-full object-cover !w-[400px]" loading="lazy" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/serene_spa_treatment.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/serene_spa_treatment.png-wvc-sizes" />
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <h2 className="font-default text-[42px] leading-tight text-primary">
              Restorative Body & Wellness Modalities
            </h2>
            <p className="font-sans text-[18px] leading-relaxed text-foreground/90">At Portland Wellness Spa, our body treatments are built around getting you real results. Whether you're dealing with built-up tension, sore muscles, or just need a full reset, our staff tailor every session to what your body needs.&nbsp;</p>
            <div className="flex flex-wrap gap-4">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-6 py-3 font-sans transition-transform hover:scale-[1.02]" asChild>
                
              </Button>
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-6 py-3 font-sans transition-transform hover:scale-[1.02]" asChild>
                <Link to="/ContactPage" className="inline-block">Book Today</Link>
              </Button>
            </div>
            <div className="w-24 h-1" style={{
            backgroundColor: "hsl(30, 30%, 45%)"
          }} />
          </div>
        </div>

        <div className="md:hidden flex flex-col gap-8">
          <div className="relative flex justify-center">
            <div className="absolute w-48 h-48 rounded-lg" style={{
            backgroundColor: "hsl(145, 15%, 85%)",
            top: "10px",
            right: "-10px",
            zIndex: 0
          }} />
            <div className="relative z-10 w-44 h-40 rounded-lg overflow-hidden shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/serene_spa_treatment.png" alt="Holistic Body Therapy" className="w-full h-full object-cover" loading="lazy" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/serene_spa_treatment.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/serene_spa_treatment.png-wvc-sizes" />
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <h2 className="font-default text-2xl leading-tight text-primary">
              Restorative Body & Wellness Modalities
            </h2>
            <p className="font-sans text-base leading-relaxed text-foreground/90">
              Experience a sanctuary of healing at Portland Wellness Spa, where our specialized body treatments are designed to release tension and restore your natural equilibrium. Our practitioners utilize forest-inspired techniques and sage-infused oils to provide a non-clinical, deeply professional environment for your recovery.
            </p>
            <div className="flex flex-col gap-4">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-6 py-3 font-sans" asChild>
                <Link to="/ContactPage" className="inline-block">
                  Book Your Treatment
                </Link>
              </Button>
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-6 py-3 font-sans" asChild>
                <Link to="/ContactPage" className="inline-block">
                  View Our Services
                </Link>
              </Button>
            </div>
            <div className="w-16 h-1" style={{
            backgroundColor: "hsl(30, 30%, 45%)"
          }} />
          </div>
        </div>
      </div>
    </section>;
}